import { COMMON } from "../../util/localizations";

const TRANSLATIONS = {
    en: {
        about: COMMON.en.about,
        appName: COMMON.appName,
        attemptingFork: 'Attempting copy...',
        close: COMMON.en.close,
        collection: COMMON.en.collection,
        download: 'Save Board',
        fileCorrupt: COMMON.en.fileCorrupt,
        fileIncorrect: `You must select a valid board file.`,
        fileLoaded: `Loaded, "{0}".`,
        fork: 'Make a Copy',
        loadBlockchain: 'Load from Blockchain',
        marketplace: COMMON.en.marketplace,
        mint: COMMON.en.mintToBlockchain,
        offers: COMMON.en.offers,
        open: 'Open Locally Saved Board',
        successfulFork: 'Copied board, "{0}".',
        startNew: 'Start New Board',
        telegram: 'Join our Telegram'
    }
}

export default TRANSLATIONS